/**
 * Wordmark - "code-league" styled text component
 * Split color: code- (white) + league (cyan)
 */

import React from 'react';
import './Logo.css';

interface WordmarkProps {
  size?: 'small' | 'medium' | 'large' | 'hero';
  className?: string;
}

export const Wordmark: React.FC<WordmarkProps> = ({ size = 'medium', className = '' }) => {
  return (
    <div className={`logo-wordmark logo-wordmark-${size} ${className}`}>
      <span className="code">code-</span>
      <span className="league">league</span>
    </div>
  );
};

